<template>
  <div class="about">
      <div class="about__title">
        <h1>Контакты</h1>
      </div>
      <div class="about_content">
          <div class="about_content_block">
                <div class="about_content_block_l">
                    <h3>
                      Отдел продаж
                    </h3>
                    <p>
                      <span class="mdi mdi-phone"></span> +7 (707) 304-92-33
                    </p>
                    <h3>
                      Обработка заказов
                    </h3>
                    <p>
                      <span class="mdi mdi-phone"></span> +7(707) 304-92-33
                    </p>
                    <p>
                      <span class="mdi mdi-phone"></span> +7 (777) 554-23-32
                    </p>
                    <h3>
                      Почта
                    </h3>
                    <p>
                      <span class="mdi mdi-email"></span> eco_dom04.kz
                    </p>
                    <h3>
                        График работы офиса
                    </h3>
                    <p>
                      <span class="mdi mdi-calendar-clock"></span> с 9-00 до 18-00 чч
                    </p>
                </div>
                <div class="about_content_block_r">
                    <h3>
                        График работы магазина
                    </h3>
                    <p>
                      <span class="mdi mdi-calendar-clock"></span> (Казахстан, Актобе, проспект Алии Молдагуловой 30) с 10-00 до 20-00
                    </p>
                    <p>
                      <span class="mdi mdi-calendar-clock"></span> (Казахстан, Актобе, проспект Кенеса Нокина, 34Б Гипермаркет "Анвар") с 10-00 до 22-00 ч
                    </p>
                    <p>
                      <span class="mdi mdi-calendar-clock"></span> (Казахстан, Актобе, Батыс-2 ул.Маннелик ел д 20/1 1 этаж) с 10-00 до 22-00 ч
                    </p>
                    <h3>
                        Дополнительная информация
                    </h3>
                    <p>
                      <span class="mdi mdi-car"></span> Доставка межгород Казпочта,ТК 7-14 дней
                    </p>
                    <p>
                      <span class="mdi mdi-car"></span> Доставка по городу Яндекс такси. 
                    </p>
                </div>
          </div>
      </div>
      <div class="flex_contacts_maps">
        <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Aa43501721d824e6689adfd3c9ff82a56799654a083f381d44c8a75fb612738d3&amp;source=constructor" class="map_contacts" frameborder="0"></iframe>
        <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Ad3173b76d89b1bef173734648dd8833dc02e910845ed1642d898d2ee9ff68312&amp;source=constructor" class="map_contacts" frameborder="0"></iframe>
        <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3A015e8031b61e281aa4d80b38c28fc890c7f88deb4a5afd08a62d7e14bc8d14fe&amp;source=constructor" class="map_contacts" frameborder="0"></iframe>
      </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  components: {
  },
  data () {
      return {
         
      }
  },
  methods: {
     
  }
}
</script>
<style scoped lang="less">
@baseMedia: 900px;
.about {
    width: 1200px;
    margin: 0 auto;
    background: white;
    @media (max-width: @baseMedia) {
        width: 95%;
    }
    .about__title {
        width: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: center;
        @media (max-width: @baseMedia) {
            padding-top: 10px;
            padding-bottom: 10px;
        }
        h1 {
            color: #4a4a4a;
            font-size: 30px;
            @media (max-width: @baseMedia) {
                font-size: 20px;
            }
        }
    }
    .about_content {
       width: 95%;
       margin: 0 auto;
       padding-bottom: 20px;
       .about_content_block {
         padding: 20px;
         border: 2px dotted #ccc;
         display: flex;
         justify-content: space-between;
         @media (max-width: @baseMedia) {
            padding: 10px;
            justify-content: center;
            flex-wrap: wrap;
          }
         .about_content_block_l {
           width: 50%;
           border-right: 2px dotted #ccc;
           @media (max-width: @baseMedia) {
                width: 100%;
                border-right: 0px;
           }
           h3 {
             margin-bottom: 10px;
             font-size: 22px;
             color: #4a4a4a;
             @media (max-width: @baseMedia) {
                font-size: 18px;
              }
           }
           p {
             margin-bottom: 10px;
             margin-left: 10px;
             font-size: 19px;
             color: #4a4a4a;
             @media (max-width: @baseMedia) {
                font-size: 15px;
              }
           }
         }
         .about_content_block_r {
           width: 50%;
           padding-left: 20px;
           @media (max-width: @baseMedia) {
                width: 100%;
                padding-left: 0;
           }
           h3 {
             margin-bottom: 10px;
             font-size: 22px;
             color: #4a4a4a;
             @media (max-width: @baseMedia) {
                font-size: 18px;
              }
           }
           p {
             margin-bottom: 10px;
             margin-left: 10px;
             font-size: 19px;
             color: #4a4a4a;
             @media (max-width: @baseMedia) {
                font-size: 15px;
              }
           }
         }
       }
    }
    .flex_contacts_maps {
       width: 95%;
       margin: 0 auto;
       display: flex;
       justify-content: space-between;
       padding-bottom: 20px;
       flex-wrap: wrap;

       @media (max-width: @baseMedia) {
          justify-content: center;
          flex-wrap: wrap;
        }
       .map_contacts {
         width: 49%;
         height: 300px;
         border: 2px dotted #ccc;
         margin-bottom: 10px;
         @media (max-width: @baseMedia) {
              width: 100%;
              margin-bottom: 10px;
          }
       }
    }
}
</style>